/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Source_PhotosInputs */

const cs_property_ai_source_photos = /** @type {(inputs: Property_Ai_Source_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdrojové fotky`)
};

const en_property_ai_source_photos = /** @type {(inputs: Property_Ai_Source_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source photos`)
};

/**
* | output |
* | --- |
* | "Source photos" |
*
* @param {Property_Ai_Source_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_source_photos = /** @type {((inputs?: Property_Ai_Source_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Source_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_source_photos(inputs)
	return cs_property_ai_source_photos(inputs)
});